import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { SequenceTemplate } from "../types";

export const useSequences = () => {
  return useQuery({
    queryKey: ['active-sequences'],
    queryFn: async () => {
      console.log("Fetching sequences...");
      
      const { data: sequenceData, error: sequenceError } = await supabase
        .from('sequence_templates')
        .select('*')
        .order('created_at', { ascending: false });

      if (sequenceError) {
        console.error("Error fetching sequences:", sequenceError);
        throw sequenceError;
      }

      console.log("Sequence templates fetched:", sequenceData);

      const sequencesWithSteps = await Promise.all(
        sequenceData.map(async (sequence) => {
          const { data: stepsData, error: stepsError } = await supabase
            .from('sequence_steps')
            .select('*')
            .eq('sequence_id', sequence.id)
            .order('step_number', { ascending: true });

          if (stepsError) {
            console.error("Error fetching steps:", stepsError);
            return {
              id: sequence.id,
              sequence_details: {
                ...sequence,
                steps: []
              }
            };
          }

          const transformedSteps = stepsData?.map(step => ({
            step_number: step.step_number,
            channel: step.channel,
            content_template: step.content_template as { subject?: string; body: string },
            delay_hours: step.delay_hours || 0,
            auto_trigger: step.conditions ? (step.conditions as Record<string, any>).auto_trigger || false : false
          })) || [];

          return {
            id: sequence.id,
            sequence_details: {
              id: sequence.id,
              name: sequence.name,
              description: sequence.description || "",
              steps: transformedSteps,
              created_at: sequence.created_at,
              updated_at: sequence.updated_at,
              trigger_type: sequence.trigger_type,
              trigger_conditions: sequence.trigger_conditions as Record<string, any>
            }
          };
        })
      );

      console.log("Combined sequences data:", sequencesWithSteps);
      return sequencesWithSteps as Array<{ id: string; sequence_details: SequenceTemplate }>;
    }
  });
};